import Components from "./config/components";

export default [
  {
    name: "Loading",
    path: "/",
    component: Components.Loading
  },
  {
    name: "PrecompiledData",
    path: "/dati-personali",
    component: Components.PrecompiledData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PrecompiledDocument",
    path: "/patente",
    component: Components.PrecompiledDocument,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IdentityDocData",
    path: "/documento",
    component: Components.IdentityDocData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "IncomeData",
    path: "/dati-reddito",
    component: Components.IncomeData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "EmployerData",
    path: "/dati-lavoro",
    component: Components.EmployerData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PersonalData",
    path: "/anagrafica-abitazione",
    component: Components.PersonalData,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubUciConsent",
    path: "/club",
    component: Components.ClubUciConsent,
    meta: {
      redirect: true,
    },
  },
  {
    name: "ClubUciWarning",
    path: "/club-avviso",
    component: Components.ClubUciWarning,
    meta: {
      redirect: true,
    },
  },
  {
    name: "Promo",
    path: "/promo",
    component: Components.Promo,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoConfirm",
    path: "/promo-confirm",
    component: Components.PromoConfirm,
    meta: {
      redirect: true,
    },
  },
  {
    name: "PromoTerms",
    path: "/promo-terms",
    component: Components.PromoTerms,
    meta: {
      redirect: false,
    },
  },
  {
    name: "Typ",
    path: "/typ",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "Typ",
    path: "/typ-pp-club",
    component: Components.Typ,
    meta: {
      resetState: true,
      redirect: true,
    },
  },
  {
    name: "TypKO",
    path: "/typ-ko",
    component: Components.TypKO,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "RequestKO",
    path: "/ko",
    component: Components.RequestKO,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "RequestExpired",
    path: "/expired",
    component: Components.RequestExpired,
    meta: {
      resetState: true,
      redirect: false,
    },
  },
  {
    name: "RequestPending",
    path: "/pending",
    component: Components.RequestPending,
    meta: {
      resetState: true,
      redirect: false,
    },
  }
];
